module.exports = __webpack_public_path__ + "static/interstate-bold-23952e8171ef751ead5c7eb2fe2bd07f.woff2";